export var partnerClientsSummaryMapper = function (clients) {
    var partnerClientsSummary = {
        totalAUM: 0,
        numberOfClients: 0,
    };
    if (clients === null || clients === void 0 ? void 0 : clients.length) {
        clients === null || clients === void 0 ? void 0 : clients.forEach(function (entry) {
            partnerClientsSummary.totalAUM += entry.totalAua;
            partnerClientsSummary.numberOfClients += entry.totalCustomerCount;
        });
    }
    return {
        partnerClientsSummary: partnerClientsSummary,
    };
};
